<template>
    <div class="manage-sites message-box-buttons">
        <button
        v-if="!userSubscriptionDetails.endsAt"
            class="btn"
            @click="openUpgradeModal"
        >
            Add More Sites
        </button>
        <router-link to="/settings/sites" class="arrow-link">
            Manage Sites <i class="far fa-long-arrow-right" />
        </router-link>
    </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters(['userSubscriptionDetails']),
    },
    methods: {
        ...mapMutations(['changeUIState']),

        /**
         * Opens upgrade modal
         */
        openUpgradeModal() {
            this.changeUIState({ isUpgradeProModalVisible: true });
        },
    },
};
</script>
